import env from "react-dotenv"
import { io } from "socket.io-client"

class SocketService {
  constructor() {
    this.socket = null
    this.connectionPromise = null
  }

  async connect() {
    if (this.socket?.connected) {
      return this.socket
    }

    if (this.connectionPromise) {
      return this.connectionPromise
    }

    if (!this.socket) {
      this.socket = io(env.MESSAGE_MANAGER_WS, {
        reconnectionAttempts: 5,
        timeout: 5000
      })
    } else {
      this.socket.connect()
    }

    this.connectionPromise = new Promise((resolve, reject) => {
      const handlers = {}

      const cleanup = () => {
        clearTimeout(handlers.timeout)
        this.socket?.off("connect", handlers.handleConnect)
        this.socket?.off("connect_error", handlers.handleError)
        this.connectionPromise = null
      }

      const handleConnect = () => {
        cleanup()
        console.log("✅ WebSocket conectado:", this.socket.id)
        resolve(this.socket)
      }

      const handleError = (error) => {
        cleanup()
        console.error("❌ Erro ao conectar WebSocket:", error.message)
        reject(error)
      }

      handlers.handleConnect = handleConnect
      handlers.handleError = handleError
      handlers.timeout = setTimeout(() => {
        cleanup()
        reject(new Error("Timeout ao conectar WebSocket"))
      }, 10000)

      this.socket.once("connect", handleConnect)
      this.socket.once("connect_error", handleError)
    })

    return this.connectionPromise
  }

  registerConnectionErrorHandler(callback) {
    if (this.socket) {
      this.socket.on("connect_error", callback)
    }
  }

  offConnectionErrorHandler(callback) {
    this.socket?.off("connect_error", callback)
  }

  registerConnectionHandler(callback) {
    this.socket?.on("connect", callback)
  }

  offConnectionHandler(callback) {
    this.socket?.off("connect", callback)
  }

  // Função para enviar uma mensagem para o chat específico
  sendMessage(chatData = {}) {
    this.socket.emit("attendant_send_message", chatData)
  }
  
  // Função para enviar uma mensagem para o chat específico
  attendantNewChat(chatData = {}) {
    this.socket.emit("attendant_new_chat", chatData)
  }

  // Inscrever-se na sala do chat específico
  joinChat(chatId) {
    if (this.socket) {
      this.socket.emit("join_chat", chatId) // O cliente entra na sala do chat
    } else {
      console.error("Socket not connected.")
    }
  }

  // Entrar na sala da organização
  joinChatOrganization(organizationId) {
    if (this.socket && organizationId) {
      this.socket.emit("join_chat_organization", organizationId)
      console.log("Entrou na organização:", organizationId)
    }
  }

  // Entrar na sala da organização
  joinWppOrganization(organizationId) {
    if (this.socket && organizationId) {
      this.socket.emit("join_wpp_organization", organizationId)
      console.log("Entrou na WPP ORG:", organizationId)
    }
  }

  // Entrar na sala da organização
  joinWppStatusOrganization(organizationId) {
    if (this.socket && organizationId) {
      this.socket.emit("join_wpp_status_organization", organizationId)
      console.log("Entrou na WPP ORG:", organizationId)
    }
  }

  // Callback para receber novas mensagens
  onNewMessage(callback) {
    this.socket.on("new_message", (payload) => {
      try {
        callback(payload)
      } catch (error) {
        console.error("Erro ao processar a mensagem recebida:", error)
      }
    })
  }
  
  // Receber notificações de novos chats
  onUpdateChat(callback) {
    if (this.socket) {
      this.socket.on("update_chat", callback)
    } else {
      console.warn("Socket not initialized yet")
    }
  }

  // Receber notificações de novos chats
  wppHasBeenDisconnect(callback) {
    if (this.socket) {
      this.socket.on("wpp_has_been_disconnect", callback)
    } else {
      console.warn("Socket not initialized yet")
    }
  }

  // Receber notificações de novos chats
  wppChangeStatus(callback) {
    if (this.socket) {
      this.socket.on("wpp_change_status", callback)
    } else {
      console.warn("Socket not initialized yet")
    }
  }

  offWppChangeStatus(callback) {
    this.socket?.off("wpp_change_status", callback)
  }

  onRefreshChat() {
    if (this.socket) {
      this.socket.on("chat:refresh")
    } else {
      console.warn("Socket not initialized yet")
    }
  }

  // Desconectar do WebSocket
  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    } else {
      console.error("Socket is not connected")
    }
  }

  leaveChat(chatId) {
    if (this.socket) {
      this.socket.emit("leave_chat", chatId) // Cliente avisa que saiu da sala do chat
    } else {
      console.error("Socket not connected.")
    }
  }

  offNewMessage(callback) {
    if (this.socket) {
      this.socket.off("new_message", callback)
    }
  }

  assumeChat(chatId, organizationId, agent) {
    // Emitir o evento 'chat:assume' para o servidor
    this.socket.emit("chat:assume", { chatId, organizationId, agent })
  
    // // O servidor deve processar a requisição e retornar uma resposta
    // socket.on("chat:confirmed", (data) => {
    //   if (data.chatId === chatId) {
    //     // A resposta será recebida quando o servidor confirmar que o chat foi assumido
    //     console.log(`Chat ${chatId} foi assumido com sucesso pelo agente ${agent.name}`);
    //     // Aqui você pode chamar uma função para atualizar o estado do frontend, se necessário
    //   }
    // });
  
    // // Caso ocorra algum erro no processo de assumir o chat
    // socket.on("chat:error", (error) => {
    //   console.error("Erro ao assumir o chat:", error.message);
    // });
  };

  finishChat(chatId) {
    if (this.socket) {
      this.socket.emit("chat:finish", { chatId })
    } else {
      console.warn("Socket not initialized")
    }
  }

  updateChatNewUser(chat) {
    if (this.socket) {
      this.socket.emit("chat:update_client", chat)
    } else {
      console.warn("Socket not initialized")
    }
  }
}

export const socketService = new SocketService()
